<script>
import codeTable from '@/components/table';
import edit from './codeEdit';
import topBar from './topbar';
import columnsConfig from '@/modules/config/columns';
import {mapActions, mapMutations, mapGetters} from 'vuex';
export default {
	created() {
		this.handleGetCarouselList();
		// this.getPhotoStatus();
		this.promiseRequest();
	},
	data() {
		return {
			carouseOption: {
				data: [],
				pageQuery: {
					total: 0,
					pageSize: 20,
					currentPage: 1,
					pageSizeList: [20, 40, 60]
				},
				searchQuery: {
					name: '',
					status: '',
					queryTimeBegin: '',
					queryTimeEnd: ''
				}
			},
			editOption: {
				type: 0, // 0新增， 1编辑
				width: '40%',
				title: '新增',
				dialog: false,
				row: {}
			},
			selectOptions: {
				status: [],
                type: []
			}
		}
	},
	methods: {
		// async getPhotoStatus() {
		// 	const {data} = await this.photoStatus();
		// 	this.selectOptions.status = data || [];
		// },
        promiseRequest() {
            Promise.all([this.carouseType(), this.photoStatus()]).then(res => {
                this.selectOptions.status = res[1].data || [];
                this.selectOptions.type = res[0].data || [];
            });
        },
		handleDelete(row){
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delete(row);
            })
		},
        async delete(row) {
            const id = row.id;
			const {code} = await this.carouseDel({id});
			if (Object.is(code, 200)) {
				this.$message.success('删除成功');
				this.handleGetCarouselList();
			}
        },
		handleEdit(row, type, title) {
			this.editOption.type = type;
			this.editOption.title = title;
			this.editOption.row = row;
			this.editOption.dialog = true;

			this.$nextTick(()=> {
				this.$refs.edit.initQuery(row);
			});
		},
		handleAdd() {
			this.handleEdit({}, 0, '新增');
		},
		async handleGetCarouselList() {
			this.$loading(true);
			const {searchQuery, pageQuery} = this.carouseOption;
			const {pageSize, currentPage} = pageQuery;
			try {
				const {code, data} = await this.getCarouseList({
					...searchQuery,pageSize, currentPage
				});
				this.carouseOption.data = data.dataSource || [];
				this.carouseOption.pageQuery.total = data.total;
			} catch (e) {
				throw e;
			} finally {
			    this.$loading(false);
			}
		},
		switchChange(status, id){
			this.updateStatus({id, status});
		},
		...mapActions('zft',['getCarouseList', 'carouseType', 'carouseAdd', 'carouseUpdate', 'carouseDel', 'photoStatus', 'updateStatus'])
	},
	computed: {
		columns() {
			return columnsConfig;
		}
	},
	components: {
		codeTable, topBar, edit
	}
}
</script>
<template>
<div class="rule-list">
	<top-bar :handlerSearch="handleGetCarouselList"
	  :searchQuery="carouseOption.searchQuery"
	  @handleAdd="handleAdd"
	  :selectOptions="selectOptions"
	></top-bar>
    <code-table
     :data="carouseOption.data"
     :columns="columns.carouselColumns"
     :searchEvent="handleGetCarouselList"
     :pageOptions="carouseOption.pageQuery"
    >
	    <el-table-column label="图片" align="center" width="100" slot="address">
            <template slot-scope="scope">
				<el-image :src="scope.row.address" style="width: 40px; height: 40px" :preview-src-list="[scope.row.address]"></el-image>
	        </template>
        </el-table-column>
        <el-table-column label="起禁用状态" align="center" width="90" slot="disableState">
            <template slot-scope="scope">
				<el-switch  v-model="scope.row.status" @change="switchChange($event, scope.row.id)"
					active-color="#8ab044"
					:inactive-value="2"
					:active-value="1"
				>
				</el-switch>
	        </template>
        </el-table-column>
		<el-table-column label="操作" align="center" width="160" slot="operate" fixed="right">
            <template slot-scope="scope">
	        	<el-button type="success" @click="handleEdit(scope.row, 1, '编辑')">编辑</el-button>
	        	<el-button type="success" @click="handleDelete(scope.row)">删除</el-button>
	        </template>
        </el-table-column>

    </code-table>
    <edit ref="edit"
	  :codeEvent="+editOption.type === 0 ? carouseAdd : carouseUpdate"
	  :searchEvent="handleGetCarouselList"
	  :editOption="editOption"
      :selectOptions="selectOptions"
	></edit>
</div>
</template>
<style scoped lang="stylus">
.rule-list
    padding 20px 20px 0
</style>
